import { ECHARTS_DATASOURCE_METRICS_PC_CONSOLE } from '@intelligence/utils/constant';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE, TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { TOPCHARTS_COMMON_DOWNLOAD_API, publisherCheckboxList } from './common';
import InfoDoc from '@intelligence/_locales/en-US/infoDoc';
import InfoDocCN from '@intelligence/_locales/zh-CN/infoDoc';

export default {
  [`${PC_CONSOLE_COMBINE_ENTITY_TYPE}-${TopchartPageId.PCConsoleMetricsTable}-studio`]: {
    // apiUrl: '/api/v1/intelligence_pc/topChartPcConsoleMetricsBigQueryExcel',
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        type: 'text',
        label: 'dbi_device',
        text: 'devices',
      },
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeMetricSelector',
        field: 'metrics',
        /**
         * combine端MetricsTable榜单页下载 级联指标筛选器默认值 是 页面的 级联指标筛选器勾选的指标作为默认值（宽表上方的级联指标筛选器）
         * 所以这里的defaultValue配置无用
         */
        defaultValue: [],
        cascadeOptions: [
          ...ECHARTS_DATASOURCE_METRICS_PC_CONSOLE,
          {
            text: 'Store Rating',
            value: 'metacritic',
            disabled: false,
            messageKey: 'dbi_info_store_rating_disabled_tips',
            messagekey: 'dbi_info_store_rating_disabled_tips',
            message: InfoDoc.dbi_info_store_rating_disabled_tips,
            messageCN: InfoDocCN.dbi_info_store_rating_disabled_tips,
            children: [
              { text: 'MetaCritic Score', value: 'meta_score' },
            ],
          },
        ],
      },
      // V1208迭代融合ID下载添加发行商信息后端未排期
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_pcu_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{label: 'steamcharts', value: 'pcu'}]
          },
          {
            label: 'dbi_digital_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{label: 'mscience', value: 'digitalRevenue'}]
          },
          {
            label: 'dbi_physical_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{label: 'npd', value: 'revenue'}]
          },
          {
            label: 'dbi_premium_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{label: 'vginsights', value: 'est_revenue'}]
          },
          {
            label: 'dbi_price_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{label: 'vginsights', value: 'est_price'}]
          }
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
};
